import React from "react";

export default function ClubEvents() {
  return <div>ClubEvents</div>;
}
